module.exports = __webpack_public_path__ + "img/fsni_6.b9b78ffe.jpg";